import React, { useEffect, useRef, useState } from 'react'
import { DataTable } from '../../CommonComponent';
import { DatePicker } from "@fluentui/react";
import { PrimaryButton, SecondaryButton } from "@softura/fluentuipackage";
import { calendar, searchWhitesvg, xlactive } from '../../../assets/images';
import { selectors as imgSelector, selectors as headerSelector } from '../../../state/features/header';
import { useSelector } from 'react-redux';
import { RESOURCE } from '../../../const/resource';
import { useTranslation } from "react-i18next";
import "./punchouthistory.scss"
import { IProps } from './punchouthistoryinterface';
import partsService from "../../../services/partsservice";
import helperfunctions from '../../../utils/helperfunctions';
import { selectors as globalDataSelector } from "../../../state/features/common/globaldata";
import moment from "moment";
import { ExcelExport, ExcelExportColumn, KendoOoxml } from '@progress/kendo-react-excel-export';
import { saveAs } from "@progress/kendo-file-saver";
import Loader from '../../Loader';


const UnitPriceFormat = (item: any) => {
    return (<td><span className="float-right">{`$${helperfunctions.formatAmount(item.dataItem.unitPrice ?? 0)}`}</span></td>)
}

const DetailComponent = (props: any) => {
    const { t } = useTranslation();
    
    const {
        headercurrentuser
    }: any = useSelector(
        state => ({
            headercurrentuser: headerSelector.currentuser(state)
        })
        );
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [puchoutDetailData, setPunchoutDetailData] = useState<[]>([]);
    const nestedColumns = [
        {
            field: 'partNumber',
            title: t(RESOURCE.MyK_Grid_Parts_Number),
            columnMenu: 'ColumnMenu',
            sortable: true,
            filterable: true,
        },
        {
            field: "machine",
            title: t(RESOURCE.MyK_Grid_Machine),
            columnMenu: 'ColumnMenu',
            sortable: true,
            filterable: true,
        },
        {
            field: 'manufacturer',
            title: t(RESOURCE.MyK_Grid_Manufacturer),
            sortable: true,
            filterable: true,
            columnMenu: 'ColumnMenu'
        },
        {
            field: 'description',
            title: t(RESOURCE.MyK_Grid_Description),
            sortable: true,
            filterable: true,
            columnMenu: 'ColumnMenu'
        },
        {
            field: 'quantity',
            title: t(RESOURCE.MyK_Grid_Quantity),
            sortable: true,
            filterable: true,
            filter: "numeric",
            columnMenu: 'ColumnMenu'
        },
        {
            field: 'unitPrice',
            title: t(RESOURCE.MyK_Label_ShoppingCart_Unit_Price),
            sortable: true,
            filterable: true,
            filter: "numeric",
            columnMenu: 'ColumnMenu',
            cell: (item: any) => UnitPriceFormat(item)
        },
    ]

    useEffect(() => {
        getPunchoutHistoryDetails();
    }, [])

    const getPunchoutHistoryDetails = () => {
        setIsLoading(true);
        const model = {
            orderId: props.dataItem.punchoutNumber,
            userID: headercurrentuser?.azureADId
        }
        partsService.getPunchoutHistoryDetails(model)
            .then((response: any) => {
                setIsLoading(false);
                setPunchoutDetailData(response ?? []);
            })
            .catch((e: any) => {
                setIsLoading(false);
                helperfunctions.showErrorMessage(e);
            });
    }

    return (
        <div>
            {isLoading && <Loader/>}
            <DataTable
                data={puchoutDetailData}
                dataColumn={nestedColumns}
                reorderable={true}
            />
        </div>
    )
}


const PunchOutHistory = ({ columns }: IProps) =>
{
    const { t } = useTranslation();
    const { imgBaseUrlSelectors }: any = useSelector((state) => ({
        imgBaseUrlSelectors: imgSelector.imgbaseUrl(state),
      }));
    const imgUrl = imgBaseUrlSelectors;
    const [punchoutData, setPunchoutData] = React.useState<[]>([]);
    const [fromDate, setFromDate] = React.useState<Date>(startOfMonth(new Date()));
    const [toDate, setToDate] = React.useState<Date>(new Date());
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isExport, setIsExport] = useState<boolean>(false);
    const {
        headercurrentuser,
        globalData
    }: any = useSelector(
        state => ({
            headercurrentuser: headerSelector.currentuser(state),
            globalData: globalDataSelector.globaldata(state),
        })
        );

    const exportRef = React.createRef<ExcelExport>();
    const gridRef = useRef<any>();
    useEffect(() =>
    {
        getPuchoutHistory();
    }, [])

    function startOfMonth(date :any) {
        return new Date(date.getFullYear(), date.getMonth(), 1);
    }

    const getPuchoutHistory = () => {
        const model = {
            customerId: globalData.CustomerId,
            locationId: globalData.LocationId,
            distributorBranch2Code: globalData.BranchCode,
            distributor4Code: globalData.DistributorCode,
            orderFrom: fromDate ? moment(fromDate).format("MM/DD/YYYY") : fromDate,
            orderTo: toDate ? moment(toDate).format("MM/DD/YYYY") : toDate,
            userID: headercurrentuser?.azureADId,
        }
        setIsLoading(true);
        partsService.getPunchoutHistory(model)
            .then((response: any) => {

                const result = response?.map((item: any) => ({
                    ...item,
                    orderTotal: helperfunctions.formatAmount((item.orderTotal)??0),
                    punchoutDate: item.punchoutDate ? new Date(moment(item.punchoutDate).format("MM/DD/YYYY")) : item.punchoutDate,
                }));
                setPunchoutData(result ?? []);
                setIsLoading(false);
            })
            .catch((e: any) => {
                helperfunctions.showErrorMessage(e);
                setIsLoading(false);
            });
    }

    const formatFromAndToDate = (date: any) => {
        if (!date) return '';
        return moment(date).format("MM/DD/YYYY");
    };

    useEffect(() => {
        if (isExport)
        {
            exportToExcelData();
        }
    }, [isExport])

    const getWorkBook = () => {
        return exportRef?.current?.workbookOptions();
    }

    const getSheet = (workbook: any) => {
        let sheet;
        if (workbook?.sheets?.at(0) != undefined) {
            sheet = workbook?.sheets[0];
        }
        return sheet;
    }

    const getRow = (sheet: any) => {
        let rows;
        if (sheet?.rows?.at(0) != undefined) {
            rows = sheet.rows;
        }
        return rows;
    }

    const getHeaderOption = (rows: any) => {
        let headerOptions;
        let cells;
        if (rows?.at(0) != undefined) {
            cells = rows[0].cells;
        }
        if (cells?.at(0) != undefined) {
            headerOptions = cells[0];
        }
        return headerOptions;
    }

    const exportToExcelData = async () => {
        setIsLoading(true);
        let workbook = getWorkBook();
        let sheet = getSheet(workbook);
        let rows = getRow(sheet);
        let headerOptions = getHeaderOption(rows);
        let data = gridRef?.current?.data ?? punchoutData;

        for (let idx = data.length - 1; idx >= 0; idx--) {
            const model = {
                orderId: data[idx].punchoutNumber,
                userID: headercurrentuser?.azureADId
            }
            const detailData: any = await partsService.getPunchoutHistoryDetails(model);
            for (
                let detailIdx = detailData.length - 1;
                detailIdx >= 0;
                detailIdx--
            ) {
                const detail = detailData[detailIdx];
                rows.splice(idx + 2, 0, {
                    cells: [
                        { value: detail.partNumber },
                        { value: detail.machine },
                        { value: detail.manufacturer },
                        { value: detail.description },
                        { value: detail.quantity },
                        { value: helperfunctions.formatAmount(detail.unitPrice ?? 0) }
                    ],
                });
            }
            rows.splice(idx + 2, 0, {
                cells: [
                    Object.assign({}, headerOptions, { value: t(RESOURCE.MyK_Grid_Parts_Number) }),
                    Object.assign({}, headerOptions, { value: t(RESOURCE.MyK_Grid_Machine) }),
                    Object.assign({}, headerOptions, { value: t(RESOURCE.MyK_Grid_Manufacturer) }),
                    Object.assign({}, headerOptions, { value: t(RESOURCE.MyK_Grid_Description) }),
                    Object.assign({}, headerOptions, { value: t(RESOURCE.MyK_Grid_Quantity) }),
                    Object.assign({}, headerOptions, { value: t(RESOURCE.MyK_Label_ShoppingCart_Unit_Price) }),
                ],
            });

        }

        new KendoOoxml.Workbook(workbook).toDataURL().then((dataUrl) => {
            setIsLoading(false);
            setIsExport(false);
            saveAs(dataUrl, `Punchout_History_${moment().format("YYYYMMDDhhmmss")}.xlsx`);
        });

    }

    const exportToExcel = () => {
        setIsExport(true);
    };

    return (<div className='punchout-history-container'>
            {isLoading && <Loader/>}
        <div className='punchouhistory-header-block'>
            <div className='punchout-history-datepicker-block'>
                <div>
                    <label>{t(RESOURCE.MyK_DateRange_From)}</label>
                    <div className="positionRelative mr-3 mt-1">                  
                        <DatePicker
                            value={fromDate}
                            maxDate={toDate}
                            onSelectDate={(e: any) => { setFromDate(e) }}
                            formatDate={formatFromAndToDate}
                            isMonthPickerVisible={false}
                            showMonthPickerAsOverlay={true}
                        />
                        <span className='dateicon'><img src={imgUrl + calendar} alt="month" /></span>
                    </div>
                </div>
                <div>
                    <label>{t(RESOURCE.MyK_DateRange_To)}</label>
                    <div className="positionRelative mr-3 mt-1">                   
                        <DatePicker
                            value={toDate}
                            minDate={fromDate}
                            onSelectDate={(e: any) => { setToDate(e) }}
                            formatDate={formatFromAndToDate}
                            isMonthPickerVisible={false}
                            showMonthPickerAsOverlay={true}
                        />
                        <span className='dateicon'><img src={imgUrl + calendar} alt="month" /></span>
                    </div>
                </div>
                <PrimaryButton
                    className="fleetBtn punchoutSearchBtn mt-4"
                    title={t(RESOURCE.MyK_FleetLabel_Search)}
                    onClick={getPuchoutHistory}
                    text={t(RESOURCE.MyK_FleetLabel_Search)}
                >
                    <img src={imgUrl + searchWhitesvg} className="ml-2" alt={t(RESOURCE.MyK_FleetLabel_Search)} />
                </PrimaryButton>
            </div>      
            <SecondaryButton
                className="fleetBtn exportExcelBtn"
                title={t(RESOURCE.MyK_FleetLabel_Search)}
                onClick={exportToExcel}
                disabled={(punchoutData?.length??0) == 0}
                text={t(RESOURCE.MyK_Label_ExportToExcel)}
            >
                <img src={imgUrl + xlactive} className={`ml-2 exportview ${(punchoutData?.length ?? 0) == 0 ? "disabled":""}` } alt={t(RESOURCE.MyK_Label_ExportToExcel)} />
            </SecondaryButton>
        </div>
        <div className='mt-3'>
            <DataTable
                exportRef={gridRef}
                data={punchoutData}
                dataColumn={columns}
                reorderable={true}
                DetailComponent={DetailComponent}
                DetailRow={true}
                isExpandWithItemChange={true}
                dataItemKey='punchoutNumber'
                />
        </div>
        {isExport && <ExcelExport data={gridRef?.current?.data ?? punchoutData} ref={exportRef}>
            <ExcelExportColumn field="punchoutDate" title={t(RESOURCE.MyK_Label_SC_Puchout_Date)} />
            <ExcelExportColumn field="punchoutNumber" title={t(RESOURCE.MyK_Label_SC_Puchout) + " #"} />
            <ExcelExportColumn field="customerName" title={t(RESOURCE.MyK_Label_Customer_Name)} />
            <ExcelExportColumn field="distributorName" title={t(RESOURCE.MyK_Label_SC_Puchout_DistributorName)} />
            <ExcelExportColumn field="punchoutBy" title={t(RESOURCE.MyK_Label_SC_Puchout_By)} />
            <ExcelExportColumn field="noofItems" title={"# " + t(RESOURCE.MyK_Label_SC_Puchout_Of_Items)} />
            <ExcelExportColumn field="orderTotal" title={t(RESOURCE.MyK_Label_ShoppingCart_Total)} />
        </ExcelExport>}
    </div>)
}

export default PunchOutHistory;